module.exports = __webpack_public_path__ + "static/wakefield-free-bus-1e8c351630d384e71d0d57b560eb730f.jpg";